<div class="absolute left-0 top-0 w-full">
  <p-confirmDialog />
  <t-transflo-top-nav
    [homeHref]="baseUrl()"
    [portalApiBaseUrl]="portalApiUrl()"
    [portalAppUrl]="portalSiteUrl()"
    (accessTokenVerified)="handleTokenIngesting($event)"
    [localOverride]="isLocal() ? localTokens() : undefined"
    (logout)="handleLogout()" />
</div>
<div class="h-full w-full pb-2 pt-7 relative">
  @if (isTokenLoaded()) {
    <ng-content>
      <router-outlet />
    </ng-content>
  } @else {
    <div></div>
  }
</div>
